import { motion } from "framer-motion";
import { LineChart, ExternalLink } from "lucide-react";
import { SITE } from "@/data/site";

export const ChartSection = () => {
  const embedUrl = `https://dexscreener.com/solana/${SITE.dexPair}?embed=1&theme=dark&trades=0&info=0`;

  return (
    <section
      id="chart"
      className="relative py-24 md:py-32 overflow-hidden"
      data-testid="chart-section"
    >
      <div className="absolute top-1/2 right-0 w-[500px] h-[500px] bg-solana/10 blur-[130px] rounded-full -z-0" />

      <div className="relative z-10 max-w-6xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="inline-flex items-center gap-2 text-sm font-body font-bold tracking-widest uppercase text-solana mb-4">
            <LineChart className="w-4 h-4" /> Live Data
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl uppercase text-white leading-[0.95]">
            Watch The <span className="fire-gradient-text">Charge</span>
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            Live price, volume and market cap straight from Dexscreener. Green candles only.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="rounded-lg overflow-hidden border-2 border-solana/50 glow-purple bg-surface"
          data-testid="chart-embed-wrapper"
        >
          <div className="relative w-full" style={{ paddingBottom: "70%", minHeight: "420px" }}>
            <iframe
              title="Dexscreener $TGB Chart"
              src={embedUrl}
              className="absolute inset-0 w-full h-full"
              style={{ border: 0 }}
              data-testid="dexscreener-iframe"
            />
          </div>
        </motion.div>

        <div className="mt-6 text-center">
          <a
            href={SITE.links.dexscreener}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="chart-open-dexscreener"
            className="inline-flex items-center gap-2 font-body font-semibold text-gray-300 hover:text-gold transition-colors duration-300"
          >
            Open full chart on Dexscreener <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};
